"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = (props, except) => {
  const propsCustom = {};
  Object.entries(props).forEach(item => {
    const [propKey, propValue] = item;
    const regex = new RegExp("^(?!(".concat(except, ")).+"));
    if (regex.test(propKey)) {
      propsCustom[propKey] = propValue;
    }
  });
  return propsCustom;
};
exports.default = _default;